import useApiRequest from "@/lib/hooks/use-request";
import { ProductListResponseDto } from "@/lib/interfaces/product";
import { Paginated, Pagination } from "@/lib/interfaces/utils";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import ProductsDataTable from "./products-data-table";

export const ProductsFetcher = ({
  searchQuery,
  setReload,
  reload,
}: {
  searchQuery: string;
  setReload: Dispatch<SetStateAction<boolean>>;
  reload: boolean;
}) => {
  const [items, setItems] = useState<ProductListResponseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { apiRequest } = useApiRequest();
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: searchQuery.split("page=")[1] ? parseInt(searchQuery.split("page=")[1].split("&")[0]) - 1 : 0,
    pageSize: 10,
  });

  const [pageCount, setPageCount] = useState<number>(0);

  const getItemsPaginated = useCallback(async () => {
    setIsLoading(true);
    let url = `settings/products?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}`;
    const response = await apiRequest<Paginated<ProductListResponseDto>>(url, "GET");
    setIsLoading(false);
    if (response.data) {
      setItems(response.data.docs);
      setPageCount(response.data.pageCount);
    }
  }, [apiRequest, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    getItemsPaginated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, getItemsPaginated, reload]);

  return (
    <DataFetchParent
      data={items}
      isLoading={isLoading}
      renderElement={(response: ProductListResponseDto[]) => (
        <div className="w-full p-4">
          <ProductsDataTable
            data={response}
            isLoading={isLoading}
            pageCount={pageCount}
            pagination={pagination}
            setPagination={setPagination}
            setReload={setReload}
          />
        </div>
      )}
    />
  );
};

export default ProductsDataTable;
